// @ts-nocheck
import { getForms } from "@store/Framework/Store/Foundation/Components/Form/FormSelector";
import { EmptyFormHandlerParameter, FormModel } from "@store/Framework/Store/Foundation/Components/Form/FormTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = EmptyFormHandlerParameter;
type Props = {
    forms: FormModel[];
};

type HandlerType = Handler<Parameter, Props>;

export const EmptyFormInputs: HandlerType = props => {
    const stateForms = getForms(props.getState());
    const newFormsList = stateForms.map(x => {
        if (x.id === props.parameter.formId) {
            return {
                ...x,
                inputs: [],
            };
        }

        return x;
    });

    props.forms = newFormsList;
};

export const DispatchEmptyForm: HandlerType = props => {
    props.dispatch({
        type: "Foundation/Components/Form/EmptyForm",
        forms: props.forms,
    });
};

export const chain = [EmptyFormInputs, DispatchEmptyForm];

const emptyForm = createHandlerChainRunner(chain, "EmptyForm");

export default emptyForm;
